import React from 'react';
import { Menu } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

export function Navigation() {
  const [isOpen, setIsOpen] = React.useState(false);
  const location = useLocation();
  const linkClasses = "text-gray-600 hover:text-blue-600 hover:bg-blue-50 block px-4 py-2.5 rounded-lg text-base transition-colors duration-200";
  const activeClass = "bg-blue-50 text-blue-600 font-medium";

  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <span className="text-xl font-bold text-gray-900">CTC Calculator</span>
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-4">
            <Link
              to="/"
              className={`${linkClasses} ${
                location.pathname === '/' ? activeClass : ''
              }`}
            >
              Home
            </Link>
            <Link
              to="/tax-comparison"
              className={`${linkClasses} ${
                location.pathname === '/tax-comparison' ? activeClass : ''
              }`}
            >
              Tax Comparison (24-25 vs Current)
            </Link>
            <Link
              to="/tax-history"
              className={`${linkClasses} ${
                location.pathname === '/tax-history' ? activeClass : ''
              }`}
            >
              Tax History
            </Link>
            <Link
              to="/contact"
              className={`${linkClasses} ${
                location.pathname === '/contact' ? activeClass : ''
              }`}
            >
              Contact Us
            </Link>
            <Link
              to="/privacy"
              className={`${linkClasses} ${
                location.pathname === '/privacy' ? activeClass : ''
              }`}
            >
              Privacy Policy
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex items-center md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-lg text-gray-600 hover:text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 transition-colors duration-200"
            >
              <span className="sr-only">Open main menu</span>
              <Menu className="block h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden ${isOpen ? 'block' : 'hidden'}`}>
        <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-100">
          <Link
            to="/"
            className={`${linkClasses} ${
              location.pathname === '/' ? activeClass : ''
            }`}
            onClick={() => setIsOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/tax-comparison"
            className={`${linkClasses} ${
              location.pathname === '/tax-comparison' ? activeClass : ''
            }`}
            onClick={() => setIsOpen(false)}
          >
            Tax Comparison (24-25 vs Current)
          </Link>
          <Link
            to="/tax-history"
            className={`${linkClasses} ${
              location.pathname === '/tax-history' ? activeClass : ''
            }`}
            onClick={() => setIsOpen(false)}
          >
            Tax History
          </Link>
          <Link
            to="/contact"
            className={`${linkClasses} ${
              location.pathname === '/contact' ? activeClass : ''
            }`}
            onClick={() => setIsOpen(false)}
          >
            Contact Us
          </Link>
          <Link
            to="/privacy"
            className={`${linkClasses} ${
              location.pathname === '/privacy' ? activeClass : ''
            }`}
            onClick={() => setIsOpen(false)}
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </nav>
  );
}
